// extracted by mini-css-extract-plugin
export default {"container":"survey_container__sCXlE"};